export const isFullStatic = false
export const staticPath = "/home/runner/work/project-diptyque-revamp-vsf2/project-diptyque-revamp-vsf2/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"